import React from 'react';

import { ChannelListItem } from 'src/components/ChannelListItem';
import { ChannelType } from 'src/legacy/components/Channels/useChannelForm';
import { useChannelPreviewData } from 'src/legacy/components/Channels/useChannelPreviewData';
import { ExtensionItemStatus } from 'src/store/dashboard/types';
import { FileChannel } from 'src/store/files/types';
import { FormsNotificationsStatuses } from 'src/store/notifications/types';

export interface AvatarInfoType {
  name: string;
  imageUrl: string;
  fallbackColor?: string;
  isCompanyUser?: boolean;
  subAvatarInfo?: AvatarInfoType;
}

export interface ChannelOptionData {
  companyID?: string;
  fileChannel?: FileChannel;
  extensionMemberIds?: string[];
  id?: string;
  clientId?: string;
  name: string;
  avatarInfo: AvatarInfoType[];
  initialLetters?: string;
  position?: number;
  status?: FormsNotificationsStatuses | ExtensionItemStatus;
  type?: string;
  updatedDate?: string;
  membershipType?: 'group' | 'individual' | 'company';
}

export interface ChannelSidebarItemProps {
  channelType: ChannelType;
  isSelected: boolean;
  channelOption: ChannelOptionData;
  // TODO(refactor needed): the channel item data is available on the parent component
  // we don't need to pass it to the onSelect callback. We should remove it.
  onSelect: (channelData: ChannelOptionData) => void;
  isRootSelected?: boolean;
}

export const ChannelSidebarItem: React.FC<ChannelSidebarItemProps> = React.memo(
  ({ channelOption, onSelect, isSelected, channelType }) => {
    const { avatarInfo, name } = channelOption;

    const { getChannelSummary, getTotalUnreadNotificationsCount } =
      useChannelPreviewData(channelOption, channelType);

    const { time: channelSummaryTime, subTitle: channelSummarySubtitle } =
      getChannelSummary();
    const channelNotificationCounter = getTotalUnreadNotificationsCount();
    const variantType = () => {
      const channelMembershipType = channelOption.fileChannel
        ? channelOption.fileChannel.membershipType
        : (channelOption.membershipType ?? 'individual');
      return channelMembershipType === 'company' ? 'rounded' : 'circle';
    };
    return (
      <ChannelListItem
        title={name}
        subTitle={channelSummarySubtitle}
        unread={Boolean(channelNotificationCounter)}
        timestamp={channelSummaryTime}
        onSelect={() => onSelect(channelOption)}
        key={`${channelType}-channel-${name}`}
        selected={isSelected}
        avatarVariant={variantType()}
        members={avatarInfo.map(
          ({ name: avatarName, imageUrl, fallbackColor, subAvatarInfo }) => ({
            avatar: imageUrl,
            fallbackColor: fallbackColor || '',
            name: avatarName,
            subAvatarInfo: subAvatarInfo
              ? {
                  avatar: subAvatarInfo.imageUrl,
                  fallbackColor: subAvatarInfo.fallbackColor || '',
                  name: subAvatarInfo.name,
                }
              : undefined,
          }),
        )}
      />
    );
  },
);
